
<nb-card class="card">
  <app-spinner class="spinnerFotos" *ngIf="showSpinnerFotos"></app-spinner>

  <div *ngIf="!showSpinnerFotos" class="cardContainer">

    <nb-card-header class="Header">
      <h3 class="Titulos">VIN: <span>{{infoPopup.vin}}</span> | Modelo: <span>{{infoPopup.modelo == null ? "S/N" :
          infoPopup.modelo}}</span></h3>
    </nb-card-header>

    <nb-card-body class="row card-body" style="margin-top: -30px;">

      <div class="col-6 left">
         <!-- [gestures]="false" -->
        <!-- <gallery class="appGallery" id="editar" thumbWidth=100 thumbPosition="left" [items]="items"
          [itemTemplate]="itemTemplate"> 
        </gallery>-->
                
        <!-- <gallery id="lightbox" thumbPosition="left" [thumbWidth]="80" imageSize="cover" style="height:250px;"></gallery> -->

          <!-- GALERIA MAIN -->

          
            <div class="gallery-container">
              <!-- Miniaturas a la izquierda -->
              <div class="thumbnails vertical">
                <img
                  *ngFor="let img of imageData; let i = index"
                  [src]="img.thumb"
                  (click)="selectImageByIndex(i)"
                  [class.active]="i === selectedIndex"
                  alt="Miniatura">
              </div>

              <!-- Imagen principal con contador y flechas -->
                    <div class="main-image-container">
                      <div class="counter">{{selectedIndex + 1}} / {{imageData.length}}</div>

                      <div class="main-image-with-nav" style="position: relative; display: inline-block;">
                        <button 
                          class="nav-btn prev"
                          (click)="prevImage()"
                          [disabled]="selectedIndex === 0"
                          title="Imagen anterior"
                          type="button"
                        >
                          &#10094;
                        </button>

                        <img
                          [src]="selectedImageData"
                          alt="Imagen principal"
                          (click)="openLightbox()"
                          style="display: block;"
                        >

                        <button 
                          class="nav-btn next"
                          (click)="nextImage()"
                          [disabled]="selectedIndex === imageData.length - 1"
                          title="Imagen siguiente"
                          type="button"
                        >
                          &#10095;
                        </button>
                      </div>
                    </div>


            </div>


            <!-- Lightbox -->
            <div class="lightbox" *ngIf="lightboxOpen" (click)="closeLightbox()">
              <div
                class="lightbox-content with-thumbs"
                (click)="$event.stopPropagation()"
                (wheel)="onWheel($event)"
              >
                <span class="close-btn" (click)="closeLightbox()">&times;</span>

                <!-- Miniaturas izquierda en lightbox -->
                <div class="thumbnails vertical lightbox-thumbs">
                  <img
                    *ngFor="let img of imageData; let i = index"
                    [src]="img.thumb"
                    (click)="selectImageByIndex(i)"
                    [class.active]="i === selectedIndex"
                    alt="Miniatura">
                </div>

                <!-- Imagen zoomable con flechas -->
                <div class="zoom-container-with-nav">
                
                  <div class="zoom-container">
                    <div class="counter">{{selectedIndex + 1}} / {{imageData.length}}</div>
                    <img
                      [src]="selectedImageData"
                      [style.transform]="'translate(' + currentX + 'px, ' + currentY + 'px) scale(' + zoom + ')'"
                      alt="Imagen ampliada"
                      class="zoom-image"
                      (mousedown)="onMouseDown($event)"
                      (mousemove)="onMouseMove($event)"
                      (mouseup)="onMouseUp()"
                      (mouseleave)="onMouseLeave()"
                      draggable="false"
                    />
                        <button class="nav-btn prev" (click)="prevImage()">&lt;</button>
                      <button class="nav-btn next" (click)="nextImage()">&gt;</button>
                  </div>
              
                </div>
              </div>
            </div>


          <!-- END GALERIA MAIN -->






        <div class="dropdown">
          <b><span>Proceso: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.proceso == null ? "S/N" : infoPopup.proceso}}</span>
          
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3" id="inputProceso"
            placeholder="" [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="procesos"
            [(ngModel)]="procesoSelecionado" [virtualScroll]="true" [itemSize]="31" [filter]="true" scrollHeight="90px">
          </p-dropdown> -->

          <nb-select *ngIf="editar" class="dropdown-select ml-3 nb-select-custom-height" id="inputProceso"
            [(selected)]="procesoSelecionado"
            placeholder="Seleccionar proceso"
            [style.height.px]="18"
            [style.width.%]="100"
            [style.minWidth.rem]="15"
            [style.maxHeight.px]="20">
            <nb-option *ngFor="let item of procesos" [value]="item.value">{{ item.label }}</nb-option>
          </nb-select>
                
        </div>

        <div *ngIf="!tipoResponsable" class="dropdown">
          <b><span>Responsable: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.responsable}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3"
            id="inputResponsableComponente" placeholder=""
            [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="responsables"
            [(ngModel)]="responsablesSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true"
            scrollHeight="90px">
          </p-dropdown> -->

           <nb-select *ngIf="editar" class="dropdown-select ml-3 nb-select-custom-height" id="inputResponsableComponente"
            [(selected)]="responsablesSeleccionada"
            placeholder="Seleccionar responsable"
            [style.height.px]="30"
            [style.width.%]="100"
            [style.minWidth.rem]="15">
            <nb-option *ngFor="let item of responsables" [value]="item.value">{{ item.label }}</nb-option>
          </nb-select> 
        </div>

        <div *ngIf="tipoResponsable" class="dropdown">
          <b><span>Tipo Responsable: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.tipoResponsable}}</span>
        </div>

        <div class="dropdown">
          <b><span>Identificador: </span></b>
          <span class='ml-3'>{{infoPopup.identificador == null ? "S/N" : infoPopup.identificador}}</span>
        </div>

        <!-- <div class="dropdown">
          <b><span>Receptor: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.receptor == null ? "S/N" : infoPopup.receptor}}</span>
          <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3"
            id="inputResponsableComponente" placeholder=""
            [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="responsables"
            [(ngModel)]="receptorSelecionado" [virtualScroll]="true" [itemSize]="31" [filter]="true"
            scrollHeight="90px">
          </p-dropdown>
        </div> -->

        <!-- CORRECCION DE DIRECCION DE DROPDOWN -->

        <!-- <div class="dropdown">
          <b><span>Receptor: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.receptor == null ? "S/N" : infoPopup.receptor}}</span>
          <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3"
            id="inputResponsableComponente" placeholder=""
            [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="responsables"
            [(ngModel)]="receptorSelecionado" [virtualScroll]="true" [itemSize]="31" [filter]="true" scrollHeight="90px">
          </p-dropdown>
        </div> -->

        <div class="dropdown" >
          <b><span>Receptor: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.receptor == null ? "S/N" : infoPopup.receptor}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3" id="inputReceptor"
            placeholder="" [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="responsables"
            [(ngModel)]="receptorSelecionado" [virtualScroll]="true" [itemSize]="31" [filter]="true"
            scrollHeight="90px">
          </p-dropdown> -->

            <nb-select *ngIf="editar" class="dropdown-select ml-3 sin-padding nb-select-custom-height" id="inputReceptor"
              [(selected)]="receptorSelecionado"
              placeholder="Seleccionar receptor"
              [style.height.px]="30"
              [style.width.%]="100"
              [style.minWidth.rem]="15">
              <nb-option *ngFor="let item of responsables" [value]="item.value">{{ item.label }}</nb-option>
            </nb-select>
        </div>

        <div class="dropdown">
          <b><span>Cedente: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.cedente == null ? "S/N" : infoPopup.cedente}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3" id="inputCedente"
            placeholder="" [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="responsables"
            [(ngModel)]="cedenteSelecionado" [virtualScroll]="true" [itemSize]="31" [filter]="true" scrollHeight="90px">
          </p-dropdown> -->

          <nb-select *ngIf="editar" class="dropdown-select ml-3 nb-select-custom-height" id="inputCedente"
          [(selected)]="cedenteSelecionado"
          placeholder="Seleccionar cedente"
          [style.height.px]="25"
          [style.width.%]="100"
          [style.minWidth.rem]="15">
          <nb-option *ngFor="let item of responsables" [value]="item.value">{{ item.label }}</nb-option>
        </nb-select>
        </div>

      </div>

      <div class="col-6 right">

        <div class="dropdown">
          <b><span>Area Componente: </span></b>
          <span class='ml-3'>{{infoPopup.areaComponente}}</span>
        </div>

        <div class="dropdown">
          <b><span>Zona Cuadrante: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.zonaCuadranteDetalle}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3"
            id="inputZonaCuadranteDComponente" [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}"
            placeholder="" [options]="zonaCuadranteDetalle" [(ngModel)]="zonaCuadranteDetalleSeleccionada"
            [virtualScroll]="true" [itemSize]="31" [filter]="true" scrollHeight="110px">
          </p-dropdown> -->
          <nb-select *ngIf="editar" class="dropdown-select ml-3 sin-padding nb-select-custom-height" id="inputZonaCuadranteDComponente"
            [(selected)]="zonaCuadranteDetalleSeleccionada"
            placeholder="Seleccionar zona cuadrante"
            [style.height.px]="30"
            [style.width.%]="100"
            [style.minWidth.rem]="15">
            <nb-option *ngFor="let item of zonaCuadranteDetalle" [value]="item.value">{{ item.label }}</nb-option>
          </nb-select>
        </div>

        <div class="dropdown">
          <b><span>Averia: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.tipoAveria}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3" id="inputAveriaComponente"
            placeholder="" [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="tipoAveria"
            [(ngModel)]="tipoAveriaSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true">
          </p-dropdown> -->

          <nb-select *ngIf="editar" class="dropdown-select ml-3 sin-padding nb-select-custom-height" id="inputAveriaComponente"
            [(selected)]="tipoAveriaSeleccionada"
            placeholder="Seleccionar avería"
            [style.height.px]="30"
            [style.width.%]="100"
            [style.minWidth.rem]="15">
            <nb-option *ngFor="let item of tipoAveria" [value]="item.value">{{ item.label }}</nb-option>
          </nb-select>

        </div>

        <div class="dropdown">
          <b><span>Severidad: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.severidad}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3"
            id="inputSeveridadComponente" placeholder=""
            [style]="{'height': '30px', 'width': '85%', 'min-width': '15rem'}" [options]="severidad"
            [(ngModel)]="SeveridadSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true">
          </p-dropdown> -->

          <nb-select *ngIf="editar" class="dropdown-select ml-3 sin-padding nb-select-custom-height" id="inputSeveridadComponente"
            [(selected)]="SeveridadSeleccionada"
            placeholder="Seleccionar severidad"
            [style.height.px]="30"
            [style.width.%]="85"
            [style.minWidth.rem]="15">
            <nb-option *ngFor="let item of severidad" [value]="item.value">{{ item.label }}</nb-option>
          </nb-select>


        </div>

        <div class="dropdown">
          <b><span>Clasificación: </span></b>
          <span *ngIf="!editar" class='ml-3'>{{infoPopup.clasificacion}}</span>
          <!-- <p-dropdown *ngIf="editar" required class="limited-selector dropdown-select ml-3" id="inputClasificacion"
            placeholder="" [style]="{'height': '30px', 'width': '100%', 'min-width': '15rem'}" [options]="clasificacion"
            [(ngModel)]="clasificacionSeleccionada" [virtualScroll]="true" [itemSize]="31" [filter]="true"
            scrollHeight="105px">
          </p-dropdown> -->

          <nb-select *ngIf="editar" class="dropdown-select ml-3 sin-padding nb-select-custom-height" id="inputClasificacion"
            [(selected)]="clasificacionSeleccionada"
            placeholder="Seleccionar clasificación"
            [style.height.px]="30"
            [style.width.%]="100"
            [style.minWidth.rem]="15">
            <nb-option *ngFor="let item of clasificacion" [value]="item.value">{{ item.label }}</nb-option>
          </nb-select>


        </div>

        <div class="dropdown">
          <b><span>Observación: </span></b>
          <span class='ml-3'>{{infoPopup.observacion}}</span>
        </div>


        <div class="dropdown">
          <b><span>Condición Inspección: </span></b>
          <span class='ml-3'>{{infoPopup.condicionInspeccion}}</span>
        </div>

        <div class="dropdown">
          <b><span>Condición Unidad: </span></b>
          <span class='ml-3'>{{infoPopup.condicionUnidad}}</span>
        </div>

        <div class="dropdown">
          <b><span>Comentario Avería: </span></b>
          <span *ngIf="!editar" class='ml-3 comentarioAveria'>{{infoPopup.comentarioModificacion}}</span>
          <textarea [style]="{'height': '30px', 'width' : '100%', 'max-height': '100px'}" *ngIf="editar"
            [(ngModel)]="comentarioAveria" class='ml-3' cols="2" rows="10" [ngStyle]="styleTextArea()"></textarea>
        </div>

      </div>

      <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>

      <div *ngIf="!showSpinnerGuardar" class="btnsGuardar" style="position: relative;">

        <span class="faltaComentario" *ngIf="isComentarioEdicion === false">Debe agregar un comentario</span>

        <!-- (click)="lightbox.open(0, 'lightbox', {panelClass: 'fullscreen'})" -->
        <button nbButton size="small" class="buttontz float-left reporteBTN"
          (click)="openLightbox()" >
          <nb-icon nbPrefix icon="expand-outline"></nb-icon>
        </button>

        <button *ngIf="usersRol.EDITAR_AVERIAS" nbButton size="small" class="float-left buttontz reporteBTN"
          (click)="!editar ? habilitarEdicion() : deshabilitarEdicion()"
          [disabled]="!tipoAveriasLoaded && !responsablesLoaded && !severidadesLoaded && !zonaCuadDetallesLoaded">
          <span *ngIf="!editar">Editar</span>
          <nb-icon *ngIf="editar" nbPrefix icon="close-outline"></nb-icon>
        </button>

        <button *ngIf="editar" nbButton size="small" class="buttontz reporteBTN" (click)="saveEdicion()"
          [disabled]="!habilitarGuardarCambios">Guardar Cambios</button>
        <button nbButton size="small" class="buttontz reporteBTN" (click)="closeDialog()">Cancelar</button>
      </div>

    </nb-card-body>

  </div>

</nb-card>

<ng-template #itemTemplate let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
  <ng-container *ngIf="type === 'imageViewer' && index === currIndex">
    <!-- <gallery [src]="[data.src]" [config]="myConfig"></gallery> -->
  </ng-container>
</ng-template>